import React, { useState } from "react";

const Formulario = ({ img, setImg, datos, setDatos, opcion }) => {
	const [fecha, setFecha] = useState(false);
	const handlerImg = (event) => {
		const imgInp = event.target.files[0];
		if (imgInp) {
			setImg(URL.createObjectURL(imgInp));
		}
	};

	const Handler = (event) => {
		setDatos({ ...datos, [event.target.name]: event.target.value });
	};

	const setFechaHoy = () => {
		setFecha(false);
		setDatos({ ...datos, fecha: "hoy" });
	};

	const setFechaExtacta = () => {
		setFecha(true);
		setDatos({ ...datos, fecha: "" });
	};

	return (
		<div className='row'>
			<div className='medium-6 columns'>
				{opcion == "Conta Persona Natural" ? (
					<div className=''>
						<label className=''>Elige Tipo de Contrato</label>
						<select
							className=''
							id='exampleFormControlSelect1'
							value={datos.planContratado}
							name='planContratado'
							onChange={(e) => Handler(e)}
						>
							<option selected>Elige una opción...</option>
							<option value='Plan Básico'>Plan Básico</option>
							<option value='Plan Emprende'>Plan Emprende</option>
							<option value='Plan Pyme'>Plan Pyme</option>
						</select>
					</div>
				) : null}
				<label>
					Nombre Completo de Persona Natural
					<input
						type='text'
						placeholder='Juanito Esteban Perez Rosales'
						value={datos.nombre}
						name='nombre'
						onChange={(e) => Handler(e)}
					/>
				</label>
				<label>
					Rut de Persona Natural
					<input
						type='text'
						placeholder='17.123.123-K'
						value={datos.rut}
						name='rut'
						onChange={(e) => Handler(e)}
					/>
				</label>
				<div className=''>
					<label className=''>Elige Nacionalidad</label>
					<select
						className=''
						id='exampleFormControlSelect1'
						value={datos.nacionalidad}
						name='nacionalidad'
						onChange={(e) => Handler(e)}
					>
						<option selected>Elige una opción...</option>
						<option value='Chilena'>Chilena</option>
						<option value='Extranjera'>Extranjera</option>
					</select>
				</div>
				<div>
					<label>Fecha</label>
					<input
						type='radio'
						id='html'
						name='fav_language'
						value='hoy'
						onClick={(e) => setFechaHoy(e)}
					/>
					<label for='html'>HOY</label>
					<input
						type='radio'
						id='html'
						name='fav_language'
						value='fecha exacta'
						onClick={(e) => setFechaExtacta(e)}
					/>
					<label for='html'>FECHA EXACTA</label>
				</div>
				{fecha ? (
					<label>
						Fecha
						<input
							type='text'
							placeholder='4 de Agosto de 1588'
							value={datos.fecha}
							name='fecha'
							onChange={(e) => Handler(e)}
						/>
					</label>
				) : null}
				{opcion == "Conta Persona Natural" ? null : (
					<div className='Prueba'>
						<label className=''>Sube Cédula de Identidad</label>
						<input
							className=''
							accept='image/*'
							type='file'
							id='imgInp'
							onChange={handlerImg}
						/>
					</div>
				)}
				<br></br>
			</div>
			<div className='medium-6 columns ImagenCedula'>
				{opcion == "Conta Persona Natural" ? null : (
					<div>
						<h2>Cédula de Identidad</h2>
						<img
							id='blah'
							src={img}
							alt='Sube una Cedula y Previsualizala'
							style={{ height: "400px" }}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default Formulario;
